import { motion } from 'framer-motion'
import { loveMessages } from '../../data/loveMessages'

export default function FloatingLoveMessages({ count = 12 }) {
  // Generate random messages with properties
  const messages = [...Array(count)].map((_, i) => ({
    id: i,
    text: loveMessages[i % loveMessages.length],
    initialX: Math.random() * 100,
    duration: Math.random() * 20 + 15,
    delay: Math.random() * 10,
    size: ['text-xs', 'text-sm', 'text-base'][Math.floor(Math.random() * 3)],
    opacity: Math.random() * 0.15 + 0.05
  }))

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none z-0">
      {messages.map((msg) => (
        <motion.div
          key={msg.id}
          className={`absolute ${msg.size} font-serif text-primary-pink whitespace-nowrap`}
          style={{ opacity: msg.opacity }}
          initial={{
            x: `${msg.initialX}%`,
            y: '110%',
            rotate: Math.random() * 30 - 15
          }}
          animate={{
            y: '-10%',
            x: [
              `${msg.initialX}%`,
              `${msg.initialX + (Math.random() * 20 - 10)}%`
            ],
            rotate: [
              Math.random() * 30 - 15,
              Math.random() * 30 - 15
            ]
          }}
          transition={{
            duration: msg.duration,
            repeat: Infinity,
            ease: 'linear',
            delay: msg.delay
          }}
        >
          {msg.text}
        </motion.div>
      ))}
    </div>
  )
}
